import { BaseChart } from './BaseChart.js';

// const mapaData = [
//     { iso: 'EC-P', name: 'Pichincha', value: 2850000 },
//     { iso: 'EC-G', name: 'Guayas', value: 3900000 },
//     { iso: 'EC-A', name: 'Azuay', value: 740000 },
//     { iso: 'EC-M', name: 'Manabí', value: 1380000 },
//     { iso: 'EC-L', name: 'Loja', value: 450000 },
//     { iso: 'EC-O', name: 'El Oro', value: 630000 },
//     { iso: 'EC-E', name: 'Esmeraldas', value: 550000 },
//     { iso: 'EC-I', name: 'Imbabura', value: 420000 },
//     { iso: 'EC-C', name: 'Carchi', value: 170000 },
//     { iso: 'EC-H', name: 'Chimborazo', value: 460000 },
//     { iso: 'EC-X', name: 'Cotopaxi', value: 410000 },
//     { iso: 'EC-T', name: 'Tungurahua', value: 510000 },
//     { iso: 'EC-B', name: 'Bolívar', value: 180000 },
//     { iso: 'EC-F', name: 'Cañar', value: 230000 },
//     { iso: 'EC-SE', name: 'Santa Elena', value: 310000 },
//     { iso: 'EC-SD', name: 'Santo Domingo de los Tsáchilas', value: 380000 },
//     { iso: 'EC-U', name: 'Sucumbíos', value: 180000 },
//     { iso: 'EC-N', name: 'Napo', value: 110000 },
//     { iso: 'EC-D', name: 'Orellana', value: 140000 },
//     { iso: 'EC-Y', name: 'Pastaza', value: 90000 },
//     { iso: 'EC-R', name: 'Los Ríos', value: 820000 },
//     { iso: 'EC-S', name: 'Morona Santiago', value: 150000 },
//     { iso: 'EC-Z', name: 'Zamora Chinchipe', value: 100000 },
//     { iso: 'EC-W', name: 'Galápagos', value: 28000 },
// ];

export class ChoroplethMap extends BaseChart {
    constructor({
        // DATOS DEL MAPA
        /**
         * Array de objetos que representan las áreas del mapa.
         * Cada objeto debe tener: { iso: string, name: string, value: number }
         * - iso: Código único que coincide con la propiedad del GeoJSON
         * - name: Nombre legible de la provincia/área
         * - value: Valor numérico para colorear el mapa
         * Ejemplo: [{ iso: 'EC-P', name: 'Pichincha', value: 2850000 }, ...]
         */
        data = [],

        // CONFIGURACIÓN DEL MAPA
        mapType = 'Ecuador',                        // Tipo de mapa (nombre registrado en ECharts)
        nameProperty = 'ISO',                       // Propiedad del dato que coincide con el nombre del área en el mapa
        aspectScale = 1,                            // Escala de aspecto horizontal/vertical (ej: 0.75 para alargar verticalmente)

        // COLORES Y ESTILOS DE ÁREAS
        defaultAreaColor = '#eee',                  // Color de relleno por defecto de las áreas
        defaultBorderColor = '#999',                // Color de borde por defecto
        defaultBorderWidth = 0.8,                   // Grosor del borde por defecto

        // ESTILOS DE SELECCIÓN
        selectionColor = '#ff5722',                 // Color de relleno al seleccionar un área
        selectionBorderColor = '#fff',              // Color del borde al seleccionar
        selectionBorderWidth = 3,                   // Grosor del borde al seleccionar

        // ESTILOS DE HOVER
        hoverColor = '#ff8a65',                     // Color de área al pasar el mouse

        // LABELS - ETIQUETAS DE ÁREAS
        showLabels = false,                         // Mostrar u ocultar etiquetas en las áreas
        labelFormatter = null,                      // Función para personalizar contenido de etiquetas: (p) => p.data?.labelName || p.name
        labelFontSize = 12,                         // Tamaño de fuente de etiquetas
        labelColor = '#000',                        // Color del texto de la etiqueta
        labelPosition = 'inside',                   // Posición: 'inside', 'outside', 'center'

        // INTERACTIVIDAD
        roam = false,                               // Permitir zoom y desplazamiento (true, false, 'scale', 'move')
        scaleLimit = { min: 1, max: 3 },            // Límites de zoom { min, max }
        selectedMode = 'single',                    // Modo de selección: false, 'single', 'multiple'

        // PROPIEDADES BASE (se pasan a BaseChart)
        ...baseProps
    } = {}) {
        // Constructor de la clase base con configuraciones específicas
        super({
            ...baseProps,
            // Sobrescribir defaults para mapas
            showVisualMap: baseProps.showVisualMap !== undefined ? baseProps.showVisualMap : true,
            titleLeft: baseProps.titleLeft || 'right',
            visualMapLeft: baseProps.visualMapLeft || 'left',
            visualMapTop: baseProps.visualMapTop || 'bottom',
            showLegend: false, // Sin leyenda
        });

        // Propiedades específicas de ChoroplethMap
        this.data = data;
        this.mapType = mapType;
        this.nameProperty = nameProperty;
        this.dataKey = nameProperty.toLowerCase();
        this.aspectScale = aspectScale;
        this.defaultAreaColor = defaultAreaColor;
        this.defaultBorderColor = defaultBorderColor;
        this.defaultBorderWidth = defaultBorderWidth;
        this.selectionColor = selectionColor;
        this.selectionBorderColor = selectionBorderColor;
        this.selectionBorderWidth = selectionBorderWidth;
        this.hoverColor = hoverColor;
        this.showLabels = showLabels;
        this.labelFormatter = labelFormatter;
        this.labelFontSize = labelFontSize;
        this.labelColor = labelColor;
        this.labelPosition = labelPosition;
        this.roam = roam;
        this.scaleLimit = scaleLimit;
        this.selectedMode = selectedMode;
    }
    /**
     * Transformación: Modo interactivo completo
     * Habilita zoom, selección y etiquetas para exploración interactiva
     */
    transformToInteractive() {
        this.roam = true;
        this.selectedMode = 'single';
        this.showLabels = true;
        this.emphasis.focus = 'self';
        this.emphasis.blurScope = 'coordinateSystem';
        return this;
    }

    /**
     * Transformación: Vista minimalista
     * Oculta elementos UI para una presentación limpia
     */
    transformToMinimal() {
        this.showVisualMap = false;
        this.showToolbox = false;
        this.showLabels = false;
        this.defaultBorderWidth = 0.5;
        this.defaultBorderColor = '#ccc';
        return this;
    }

    getOptions() {
        const options = {
            title: this.getTitleConfig(),
            tooltip: this.getTooltipConfig((params) => {
                const nombre = params.data?.labelName || params.name;
                const valor = params.value != null ? params.value.toLocaleString() : 'Sin datos';
                return `
                    <div style="padding: 5px;">
                        <strong style="font-size: 14px;">${nombre}</strong><br/>
                        <span style="color: #ddd;">Valor:</span> <strong>${valor}</strong>
                    </div>
                `;
            }),
            series: [
                {
                    id: this.seriesId,
                    name: this.seriesName,
                    type: 'map',
                    universalTransition: this.universalTransition,
                    animationDurationUpdate: this.animationDurationUpdate,
                    animationDuration: this.animationDuration,
                    animationEasing: this.animationEasing,
                    map: this.mapType,
                    nameProperty: this.nameProperty,
                    roam: this.roam,
                    scaleLimit: this.scaleLimit,
                    aspectScale: this.aspectScale,
                    selectedMode: this.selectedMode,
                    label: {
                        show: this.showLabels,
                        fontSize: this.labelFontSize,
                        color: this.labelColor,
                        position: this.labelPosition,
                        formatter: this.labelFormatter || ((p) => p.data?.labelName || p.name),
                    },
                    itemStyle: {
                        areaColor: this.defaultAreaColor,
                        borderColor: this.defaultBorderColor,
                        borderWidth: this.defaultBorderWidth,
                    },
                    select: {
                        itemStyle: {
                            areaColor: this.selectionColor,
                            borderColor: this.selectionBorderColor,
                            borderWidth: this.selectionBorderWidth,
                        },
                        label: {
                            show: true,
                            fontSize: this.labelFontSize + 2,
                            fontWeight: 'bold',
                        }
                    },
                    emphasis: {
                        ...this.emphasis,
                        itemStyle: {
                            areaColor: this.hoverColor,
                            borderColor: this.selectionBorderColor,
                            borderWidth: Math.max(2, this.selectionBorderWidth - 1),
                            ...this.emphasis.itemStyle,
                        },
                    },
                    data: this.data.map((item) => ({
                        name: item[this.dataKey],
                        value: item.value,
                        labelName: item.name,
                    })),
                },
            ],
        };

        // Agregar visualMap usando método de la clase base
        const visualMap = this.getVisualMapConfig();
        if (visualMap) {
            options.visualMap = visualMap;
        }

        // Agregar toolbox usando método de la clase base
        const toolbox = this.getToolboxConfig();
        if (toolbox.show) {
            options.toolbox = toolbox;
        }

        return options;
    }
}